import legalDocumentApi from '../../api/legalDocument.api';

const state = {
  legalDocument: {},
  legalDocuments: [],
  legalDocumentsStatus: '',
};

const getters = {
  legalDocument: state => state.legalDocument,
  legalDocuments: state => state.legalDocuments,
  legalDocumentsStatus: state => state.legalDocumentsStatus,
};

const actions = {
  findAdminLegalDocuments({ commit }, payload) {
    commit('LEGAL_DOCUMENTS_STATUS', 'LOADING');
    return legalDocumentApi.findAdminLegalDocuments(payload)
      .then((response) => {
        commit('LEGAL_DOCUMENTS', response.legalDocuments);
        commit('LEGAL_DOCUMENTS_STATUS', 'FINISHED');
      });
  },

  addAdminLegalDocument({ commit }, payload) {
    commit('LEGAL_DOCUMENTS_STATUS', 'LOADING');
    return legalDocumentApi.addAdminLegalDocument(payload)
      .then((response) => {
        commit('ADD_LEGAL_DOCUMENT', response.legalDocument);
        commit('LEGAL_DOCUMENTS_STATUS', 'FINISHED');
      });
  },

  getAdminLegalDocument({ commit }, payload) {
    commit('LEGAL_DOCUMENTS_STATUS', 'LOADING');
    return legalDocumentApi.getAdminLegalDocument(payload)
      .then((response) => {
        commit('LEGAL_DOCUMENT', response.legalDocument);
        commit('LEGAL_DOCUMENTS_STATUS', 'FINISHED');
      });
  },

  saveAdminLegalDocument({ commit }, payload) {
    commit('LEGAL_DOCUMENTS_STATUS', 'LOADING');
    return legalDocumentApi.saveAdminLegalDocument(payload)
      .then((response) => {
        commit('LEGAL_DOCUMENT', response.legalDocument);
        commit('LEGAL_DOCUMENTS_STATUS', 'FINISHED');
      });
  },

  deleteAdminLegalDocument({ commit }, payload) {
    commit('LEGAL_DOCUMENTS_STATUS', 'LOADING');
    return legalDocumentApi.deleteAdminLegalDocument(payload)
      .then(() => {
        commit('LEGAL_DOCUMENT', {});
        commit('LEGAL_DOCUMENTS_STATUS', 'FINISHED');
      });
  },
};

const mutations = {
  LEGAL_DOCUMENT(state, legalDocument) {
    state.legalDocument = legalDocument;
  },
  LEGAL_DOCUMENTS(state, legalDocuments) {
    state.legalDocuments = legalDocuments;
  },
  ADD_LEGAL_DOCUMENT(state, legalDocument) {
    state.legalDocuments.unshift(legalDocument);
  },
  LEGAL_DOCUMENTS_STATUS(state, status) {
    state.legalDocumentsStatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
